import React, { FC, memo, useMemo, useState } from 'react';
import { faFolderOpen } from '@fortawesome/pro-light-svg-icons';
import FnButtonIcon from '../FnButtonIcon';
import { TKsfDirectoryItem } from '../../../commonTypes/basic';
import { FnAntModalWidth } from '../../blocks/FnAntModal/constants';
import { getKsfDirectoryList, getModalSize } from '../FnFilesModal/utils';
import FnFilesModal from '../FnFilesModal';

interface Props {
  data: TKsfDirectoryItem[];
  text?: string;
  directoryName?: string;
}

const KsfButton: FC<Props> = ({ data, text, directoryName }) => {
  const [isOpen, seIsOpen] = useState(false);
  const handleModalOpen = () => seIsOpen(true);
  const handleModalClose = () => seIsOpen(false);

  const ksfDirectoryList = getKsfDirectoryList(data);

  const size = useMemo((): FnAntModalWidth => {
    let maxCount = 1;
    ksfDirectoryList.forEach((item) => {
      maxCount = item.files && item.files.length > maxCount ? item.files.length : maxCount;
    });
    return getModalSize(maxCount);
  }, [ksfDirectoryList.length]);

  return ksfDirectoryList && ksfDirectoryList.length ? (
    <>
      <FnButtonIcon text={text} icon={faFolderOpen} onClick={handleModalOpen} className="folder-icon" />
      <FnFilesModal
        title={directoryName ? directoryName + ' Directory' : ''}
        data={ksfDirectoryList}
        isOpen={isOpen}
        size={size}
        onClose={handleModalClose}
      />
    </>
  ) : null;
};

export default memo(KsfButton);
